import Totals from "../../crew/Totals";
import BigNum from "../../math/BigNum";
import SkillNode from "../SkillNode";
import SkillNodePurchaseListener from "../SkillNodePurchaseListener";

export default class UnlockSkillNode extends SkillNode {
    /**
     * @param {string} id 
     * @param {string} title 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {SkillNodePurchaseListener} purchaseListener
     */
    constructor(id, title, description, totals, iconFileName, cost, purchaseListener) {
        super(id, title, description, totals, iconFileName, cost, purchaseListener);
    }
}